import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { Check } from "lucide-react";
import { BORDER_RADIUS_BUTTON } from "../../../utils/constants";

const chipSx = ({ active, disabled, theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.5,
  width: "100%",
  height: 32,
  px: 1.25,
  borderRadius: BORDER_RADIUS_BUTTON,
  border: "1px solid",
  borderColor: active ? "transparent" : "#E4E4E7",
  background: active ? theme.palette.button.primary.main : "#fff",
  color: active ? theme.palette.button.primary.contrastText : "text.primary",
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "inherit",
  appearance: "none",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  userSelect: "none",
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  ...(active && !disabled
    ? {
        "&:hover": {
          background: theme.palette.button.primary.hover.main,
          color: theme.palette.button.primary.hover.contrastText,
        },
      }
    : {}),
});

const ProduceToggleChips = ({
  options = [],
  selectedValues = [],
  onToggle,
  disabled = false,
  multiple = true,
}) => {
  const theme = useTheme();
  const selectedSet = new Set(selectedValues);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: 0.75,
      }}
    >
      {options.map((option) => {
        const selected = selectedSet.has(option.value);
        return (
          <Box
            key={option.value}
            component="button"
            type="button"
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              if (!multiple && selected) return;
              onToggle(option.value);
            }}
            sx={chipSx({
              active: selected,
              disabled,
              theme,
            })}
          >
            {option.label}
            {selected ? <Check size={13} /> : null}
          </Box>
        );
      })}
    </Box>
  );
};

export default ProduceToggleChips;
